import React, { useState } from "react"
import "./../../CompanysForm.css"

import { PaginationGrid } from "../../../../../../components/Common/PaginationGrid"

import RankingTable from "./RankingTable"
import RankingForm from "./RankingForm"

const RankingGrid = ({
  data,
  currentPage,
  setCurrentPage,
  showList,
  setShowList,
  totalPages,
  companySelected,
  setCompanySelected,
}) => {
  return (
    <>
      {showList ? (
        <>
          {!!data.length && (
            <>
              <RankingTable
                dataArray={data}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setCompanySelected={setCompanySelected}
                setShowList={setShowList}
                totalPages={totalPages}
              />
            </>
          )}
        </>
      ) : (
        <RankingForm
          companySelected={companySelected}
          setCompanySelected={setCompanySelected}
          showList={showList}
          setShowList={setShowList}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  )
}

export default RankingGrid
